'use client';

import type { ClassValue } from 'clsx';

import { useAtomValue } from '@effect/atom-react';
import { GlossaryIndexHint } from '@vs-shop/commerce-ui/glossaryIndex';
import { clsxm } from '@vs-shop/utils';
import { useIntl } from 'react-intl';

import { glossaryModeAtom } from '../../../../effect/atom/glossary/glossaryFilters';
import { GlossaryMode } from '../../../../effect/data/glossary/glossaryMode';

type Props = {
  className?: ClassValue;
};

export function GlossarySearchHint({ className }: Props) {
  const intl = useIntl();
  const mode = useAtomValue(glossaryModeAtom);

  if (mode !== GlossaryMode.search) return null;

  return (
    <GlossaryIndexHint className={clsxm(className)}>
      {intl.formatMessage({
        id: 'component.client.page.glossary.search.hint',
        defaultMessage:
          'Zobrazují se pouze nejrelevantnější pojmy, pro lepší výsledek napište přesný výraz.',
      })}
    </GlossaryIndexHint>
  );
}
